import loader from './loader'

export default {
  install (Vue) {
    Vue.directive('image-loader', {
      async bind (el, binding, vnode) {
        const image = typeof binding.value !== 'undefined'
          ? binding.value
          : el.src
        await loader(image)
        // After load create and dispatch a load event attached to el
        const loaded = new Event('loaded')
        el.dispatchEvent(loaded)
      }
    })
    Vue.prototype.$imageLoader = (...images) => { // Accept an iterable object
      const imagesPromises = images.map((image) => {
        return loader(image)
      })
      return Promise.all(imagesPromises)
    }
  }
}
